import React from "react";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Mui
import constant from "@/config/constant";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import Fade from "@mui/material/Fade";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";
import InputLabel from "@mui/material/InputLabel";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";

// import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

// import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import MenuItem from "@mui/material/MenuItem";
// Mui Styles
import { StyledButton, StyledPaper } from "@/styles/mui/globalStyles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";

//lodash
import _ from "lodash";

//fetch
import {
  createGiveawayManage,
  getGiveawayManage,
  updateGiveawayManage,
} from "@/fetch/fetchGiveaway";
import { getBrandtype } from "@/fetch/fetchProduct";

// Redux
import { giveAwayList } from "@/features/giveAwayManageSlice";
import { useCurrentAction } from "@/hooks/user";
import { useDispatch, useSelector } from "react-redux";

const GiveAwayManageDetailPage = (props) => {
  const { open, setOpen } = props;
  const actions = useCurrentAction();

  const { id } = useParams();

  // Navigate and Location and Params
  const navigate = useNavigate();
  const params = useParams();

  //reduxState
  const giveAwayManageRedux = useSelector((state) => state.giveAwayManage);
  const dispatch = useDispatch();

  // States
  const [onChangeData, setOnChangeData] = React.useState({
    is_active: true,
    region_ids: [1, 2],
  });
  const [options, setOptions] = React.useState([]);
  const [error, setError] = React.useState({
    work_address: false,
    work_district: false,
    work_name: false,
    work_shortcode: false,
    work_telephone: false,
    isExist: false,
  });
  const [save, setSave] = React.useState(false);
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            marginBottom: 10,
          },
        },
      },
    },
  });

  // Submit
  const onClickSubmit = async (id) => {
    const giveAwayData = {
      itemId: onChangeData.id,
      item_brand: onChangeData.item_brand,
      item_name: onChangeData.item_name,
      item_unit_price: onChangeData.item_unit_price,
      m18_product_code: onChangeData.m18_product_code,
      is_active: onChangeData.is_active,
      region_ids: onChangeData.region_ids,
    };

    const reqBody = {
      giveAwayData: giveAwayData,
    };

    const checkError = {
      itemdId: onChangeData.id ? false : true,
      item_brand: onChangeData.item_brand ? false : true,
      item_name: onChangeData.item_name ? false : true,
      item_unit_price: onChangeData.item_unit_price ? false : true,
      m18_product_code: onChangeData.m18_product_code ? false : true,
      isExist: giveAwayManageRedux.giveAwayList.find(
        (item) =>
          item.m18_product_code.toUpperCase().trim() ===
          onChangeData.m18_product_code?.toUpperCase().trim()
      )
        ? true
        : false,
    };

    setError((prev) => ({
      ...prev,
      ...checkError,
    }));

    if (checkError.isExist) {
      return false;
    }

    if (
      !checkError.item_brand &&
      !checkError.item_name &&
      !checkError.item_unit_price &&
      !checkError.m18_product_code
    ) {
      await updateGiveawayManage(reqBody).then((data) => {
        if (data && data.results) {
          setSnackMessage("已修改");
          setSnackOpen(true);
          setSave((prev) => !prev);
          setTimeout(() => {
            setSnackOpen(false);
            navigate(-1);
          }, 1500);
        }
      });
    } else {
      setSnackMessage("請填寫資料");
      setSnackOpen(true);
    }
  };

  const onClickSubmitCreate = async (id) => {
    const giveAwayData = {
      item_brand: onChangeData.item_brand,
      item_name: onChangeData.item_name,
      item_unit_price: onChangeData.item_unit_price,
      m18_product_code: onChangeData.m18_product_code,
      is_active: onChangeData.is_active,
      region_ids: onChangeData.region_ids,
    };

    const reqBody = {
      giveAwayData: giveAwayData,
    };

    const checkError = {
      item_brand: onChangeData.item_brand ? false : true,
      item_name: onChangeData.item_name ? false : true,
      item_unit_price: onChangeData.item_unit_price ? false : true,
      m18_product_code: onChangeData.m18_product_code ? false : true,
      isExist: giveAwayManageRedux.giveAwayList.find(
        (item) =>
          item.m18_product_code.toUpperCase().trim() ===
          onChangeData.m18_product_code?.toUpperCase().trim()
      )
        ? true
        : false,
    };

    setError((prev) => ({
      ...prev,
      ...checkError,
    }));

    if (checkError.isExist) {
      return false;
    }

    if (
      !checkError.item_brand &&
      !checkError.item_name &&
      !checkError.item_unit_price &&
      !checkError.m18_product_code
    ) {
      await createGiveawayManage(reqBody).then((data) => {
        if (data && data.results) {
          setSnackMessage("已新增");
          setSnackOpen(true);
          setSave((prev) => !prev);
          setTimeout(() => {
            setSnackOpen(false);
            navigate(-1);
          }, 1500);
        }
      });
    } else {
      setSnackMessage("請填寫資料");
      setSnackOpen(true);
    }
  };

  const fetchAllCreate = async () => {
    await getBrandtype()
      .then((data) => {
        if (data && data.results) {
          setOptions(data.data);
        }
      })
      .then(() => {
        getGiveawayManage().then((data) => {
          if (data && data.results) dispatch(giveAwayList(data.data));
        });
      });
  };

  const fetchAll = async () => {
    await getBrandtype().then((data) => {
      if (data && data.results) setOptions(data.data);
    });
    await getGiveawayManage()
      .then((data) => {
        let value;
        if (data && data.results) {
          value = data.data.find((item) => item.id === parseInt(params.id));
          setOnChangeData(value);
        }
      })
      .then(() => setSlideTranOn(true));
  };

  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };

  React.useEffect(() => {
    if (!id) {
      fetchAllCreate();
    }

    /*if a param id is passed inside , it means that this is a existing record and then execute fetchAll function to retrieve the related information to display,
    otherwise this will a new record  i won't execute fetchAll and clear option defultValues in reduxState */
    if (id) {
      fetchAll();
    } else {
      setSlideTranOn(true);
    }
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    // eslint-disable-next-line react-hooks/exhaustive-deps
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      dispatch(giveAwayList([]));
    };
  }, [save]);

  return (
    <Layout
      header="workLocationManageDetailPage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      selectedIndex={17}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`贈品管理 / ${id ? "修改贈品" : "新增贈品"}`}
        history={() => navigate(-1)}
      />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <StyledPaper page={"yes"}>
          <ThemeProvider theme={theme}>
            <Box validate="true" sx={{ width: 1, flex: 1 }}>
              <Grid container spacing={2}>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6
                  }}>
                  <TextField
                    disabled={!actions?.update}
                    id="m18_product_code"
                    name="m18_product_code"
                    label="M18號碼"
                    error={error.isExist || error.m18_product_code}
                    value={onChangeData.m18_product_code}
                    onChange={(event) => {
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      });
                      setError((prev) => ({
                        ...prev,
                        isExist: giveAwayManageRedux.giveAwayList.find(
                          (item) =>
                            item.m18_product_code.toUpperCase().trim() ===
                            event.target.value?.toUpperCase().trim()
                        )
                          ? true
                          : false,
                      }));
                    }}
                    sx={{ width: "100%" }}
                  />
                  {/*if a param id is passed inside , it means that this is a existing record and it will disable validation,
                     otherwise this will a new record  it will enable validation */}
                  {!params.id
                    ? error.isExist && (
                        <FormHelperText
                          error={!params.id ? error.isExist : false}
                        >
                          M18號碼已存在
                        </FormHelperText>
                      )
                    : false}
                  {/*///////////////////////////////////////////////////////////////////////////////////////*/}
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6
                  }}>
                  <TextField
                    disabled={!actions?.update}
                    select
                    id="staff_code"
                    name="item_brand"
                    label="品牌"
                    error={error.item_brand}
                    value={onChangeData.item_brand}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  >
                    <MenuItem disabled>請選擇</MenuItem>
                    {options.map((item, index) => {
                      return (
                        <MenuItem key={index} value={item.brand_types_name}>
                          {item.brand_types_name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6
                  }}>
                  <TextField
                    disabled={!actions?.update}
                    id="work_name"
                    name="item_name"
                    label="產品名稱"
                    error={error.item_name}
                    value={onChangeData.item_name}
                    onChange={(event) => {
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      });
                    }}
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6
                  }}>
                  <TextField
                    disabled={!actions?.update}
                    id="work_address"
                    name="item_unit_price"
                    label="產品單價價錢"
                    type="number"
                    error={error.item_unit_price}
                    value={onChangeData.item_unit_price}
                    onChange={(event) =>
                      setOnChangeData({
                        ...onChangeData,
                        [event.target.name]: event.target.value,
                      })
                    }
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6
                  }}>
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel id="select-brands-label">區域</InputLabel>
                    <Select
                      disabled={!actions?.update}
                      required
                      multiple
                      id="region_ids"
                      name="region_ids"
                      label="員工購物"
                      labelId="select-brands-label"
                      renderValue={(selected) => {
                        const selectedValue = _.map(selected, (s) => {
                          return constant.regionType[s];
                        });
                        return selectedValue.join(", ");
                      }}
                      onChange={(event) =>
                        setOnChangeData({
                          ...onChangeData,
                          [event.target.name]: event.target.value,
                        })
                      }
                      value={onChangeData.region_ids}
                    >
                      {_.map(constant.regionType, (value, key) => {
                        return (
                          <MenuItem value={parseInt(key)} key={key}>
                            <Checkbox
                              checked={onChangeData.region_ids.includes(
                                parseInt(key)
                              )}
                            />
                            <ListItemText primary={value} />
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid
                  size={{
                    xs: 12,
                    md: 6,
                    lg: 6
                  }}>
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel id="select-brands-label">狀態</InputLabel>
                    <Select
                      disabled={!actions?.update}
                      required
                      id="is_active"
                      name="is_active"
                      label="狀態"
                      labelId="select-brands-label"
                      value={onChangeData.is_active ?? true}
                      onChange={(event) =>
                        setOnChangeData({
                          ...onChangeData,
                          [event.target.name]: event.target.value,
                        })
                      }
                    >
                      <MenuItem key={"on"} value={true}>
                        開啟
                      </MenuItem>
                      <MenuItem key={"off"} value={false}>
                        關閉
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {actions?.update && (
                  <Grid
                    size={{
                      xs: 12,
                      md: 12,
                      lg: 12
                    }}>
                    <Grid justifyContent={"flex-end"} container spacing={2}>
                      <Grid
                        size={{
                          xs: 12,
                          md: 12,
                          lg: 2
                        }}>
                        <StyledButton
                          variant="contained"
                          size="small"
                          onClick={
                            id
                              ? () => onClickSubmit(id ? id : 0)
                              : () => onClickSubmitCreate(id ? id : 0)
                          }
                        >
                          <Typography
                            variant="subtitle1"
                            noWrap
                            component="div"
                          >
                            確認
                          </Typography>
                        </StyledButton>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Box>
          </ThemeProvider>
        </StyledPaper>
      </Fade>
    </Layout>
  );
};

export default GiveAwayManageDetailPage;
